export default __webpack_public_path__ + "static/media/activity_sucessfully.100a2aa8.svg";